import type {PadFrame} from "./gamepad-state";
function display(element:HTMLElement):HTMLElement{
  return element instanceof HTMLInputElement&&element.labels?.[0]?element.labels[0]:element;
}
function visible(element:HTMLElement){
  const box=display(element).getBoundingClientRect(),style=getComputedStyle(display(element));
  return !element.matches(":disabled")&&!element.closest('[hidden],[inert],[aria-hidden="true"]')&&
    box.width>0&&box.height>0&&style.visibility!=="hidden"&&style.display!=="none";
}
export function clearGamepadFocus(root:ParentNode){
  root.querySelectorAll("[data-gamepad-focus]").forEach(el=>el.removeAttribute("data-gamepad-focus"));
}
/** Navigate only the current menu/dialog, not hidden workshop or combat buttons. */
export function gamepadMenu(root:HTMLElement,frame:PadFrame){
  if(frame.nav===null&&!frame.pressed.includes(0)&&!frame.pressed.includes(1))return;
  const dialogs=Array.from(root.querySelectorAll<HTMLElement>('[role="dialog"],[data-gamepad-menu]')).filter(visible);
  const scope=dialogs.at(-1)??root;
  const items=Array.from(scope.querySelectorAll<HTMLElement>('button,a[href],input:not([type="hidden"]),select,[tabindex="0"]')).filter(visible);
  if(!items.length)return;
  const current=items.find(el=>el===document.activeElement);
  const preferred=items.find(el=>el.hasAttribute("data-gamepad-default"))??
    items.find(el=>el.closest("[data-bonk-sign-controls]")&&!el.classList.contains("bonk-back"))??items[0];
  const focus=(el:HTMLElement)=>{
    clearGamepadFocus(root);display(el).dataset.gamepadFocus="true";
    el.focus({preventScroll:true});display(el).scrollIntoView({block:"nearest",inline:"nearest"});
  };
  if(frame.nav!==null){
    if(!current)focus(preferred);
    else {
      const a=display(current).getBoundingClientRect(),x=a.x+a.width/2,y=a.y+a.height/2;
      const dx=frame.nav===14?-1:frame.nav===15?1:0,dy=frame.nav===12?-1:frame.nav===13?1:0;
      const ranked=items.filter(el=>el!==current).map(el=>{
        const b=display(el).getBoundingClientRect(),vx=b.x+b.width/2-x,vy=b.y+b.height/2-y;
        return {el,along:vx*dx+vy*dy,score:Math.hypot(vx,vy)+Math.abs(vx*dy-vy*dx)*2};
      }).filter(v=>v.along>4).sort((a,b)=>a.score-b.score);
      if(ranked[0])focus(ranked[0].el);
    }
  }
  if(frame.pressed.includes(1)){
    const back=items.find(el=>el.hasAttribute("data-gamepad-back")||el.classList.contains("bonk-back"));
    back?.click();return;
  }
  if(frame.pressed.includes(0)){
    const target=items.find(el=>el===document.activeElement)??preferred;
    focus(target);target.click();
  }
}
